<script setup lang="ts">
import type { JournalListItemDTO } from '~/shared/api/client/journals/journals.dto';
import { getJournalIssueUrl } from '~/shared/lib/journal-routes.const';
import JournalCover from './JournalCover.vue';
import JournalIssueButtons from './JournalIssueButtons.vue';

import { getIssueMeta } from '../lib/getIssueMeta';

const props = defineProps<{
  issue: JournalListItemDTO;
}>();

const meta = computed(() => getIssueMeta(props.issue));
</script>

<template>
  <article :class="$style.card">
    <!-- Cover and title open the issue, the way the grid works on cre.ru -->
    <NuxtLink :to="getJournalIssueUrl(issue)" :class="$style.link">
      <JournalCover
        :title="issue.title"
        :src="issue.cover?.file_url"
        :class="$style.cover"
      />
      <h3 :class="$style.title">{{ issue.title }}</h3>
      <p v-if="meta" :class="$style.meta">{{ meta }}</p>
    </NuxtLink>
    <JournalIssueButtons
      :issue="issue"
      size="standard"
      label="Купить"
      equal-width
      spread
    />
  </article>
</template>

<style module lang="scss">
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-5x) var(--space-2-5x);
}

.link {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: inherit;
  text-decoration: none;
}

/*
 * One box for every card in the row, so the titles and the buy buttons below
 * start at the same line whatever proportions the issue was printed in. The
 * covers keep their own, fitted into the box by height — a hair wider than the
 * widest of them, so none is cropped
 */
.cover {
  --cover-box-ratio: 0.78;

  max-width: 220px;
}

.title {
  @include text_h5;
  color: var(--color-black-1);
  margin: var(--space-5x) 0 0;
  text-align: center;
  transition: color 0.2s;
  font-size: 22px;

  .link:hover & {
    color: var(--color-red-1);
  }
}

.meta {
  @include text_body1_medium;
  color: var(--color-black-2);
  margin: var(--space-1-5x) 0 0;
  text-align: center;
}

.link {
  margin-bottom: var(--space-2-5x);
}

@media (max-width: 599px) {
  .card {
    padding: var(--space-4x) var(--space-2x);
  }

  .cover {
    max-width: 180px;
  }

  .title {
    @include text_h5_mobile;
  }

  .meta {
    @include text_caption1_medium;
  }
}
</style>
